import { createTextInputAdder } from './createTextInputAdder'

export const addComponentForUrlField = createTextInputAdder('urlFieldTemplate')
